module.exports = __webpack_public_path__ + "static/media/toka-banner.8c5398c1.png";